import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { initializeFrontendObservability } from "./utils/observability";

// Inicializar rastreamento OTEL no frontend
initializeFrontendObservability();

// Interface global para o TypeScript reconhecer o $ do jQuery e AdminLTE
declare global {
  interface Window {
    $: any;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
